module.exports = __webpack_public_path__ + "static/media/993998.58c2a34a.png";